import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useQuery } from '@tanstack/react-query';
import { CourierFileDetailApiAdapter } from '../adapters';

interface UseCourierFileDetailProps {
    fileId: number;
    enabled?: boolean;
}

export const useCourierFileDetail = ({ fileId, enabled = true }: UseCourierFileDetailProps) => {
    const httpClient = createHttpClient(apiClientWH);
    const adapter = new CourierFileDetailApiAdapter(httpClient);

    const {
        data,
        isLoading,
        isFetching,
        error,
        refetch,
    } = useQuery({
        queryKey: ['courier-cod-file', fileId],
        queryFn: () => adapter.getCourierFileById(fileId),
        enabled: enabled && !!fileId,
        staleTime: 2 * 60 * 1000, // 2 minutos
        gcTime: 5 * 60 * 1000, // 5 minutos
    });

    return {
        courierFile: data,
        isLoading,
        isFetching,
        error: error ? (error as Error).message : null,
        refetch,
    };
};

